const OPEN_URL = "api/";
const AUTH_URL = "";

const EntityConstants = {
  SIGN_UP_VERIFIER: `${OPEN_URL}verifier/signup`,
  LOGIN: `${OPEN_URL}verifier/login`,
  LOGOUT: `${OPEN_URL}verifier/logout`,
  CURRENT_USER: `${OPEN_URL}verifier/me`,
  VERIFIER_PERMISSIONS: `${OPEN_URL}verifier/permissions`,
  ONBOARDING_APPLY: `${OPEN_URL}holder/claim/process`,
  CREDENTIALS: `${OPEN_URL}credentials/received`,
  DOWNLOAD_CREDENTIALS: `${OPEN_URL}credentials/presentation`,
  WORKFLOW: `${OPEN_URL}workflow/get-workflows/?tenant_id=`,
  DASH_APPLICATION: `${OPEN_URL}holderclaimprocess/list/?holder_id=`,
  FORMS: `${OPEN_URL}workflow/get-workflowsteps/?workflow_id=`,
  CONTINUE_FORM: `${OPEN_URL}claim/details/?holder_claim_process_id=`,
  APPLICATIONS: `${OPEN_URL}audit/applications/list`,
  APPLICATION_DETAIL: `${OPEN_URL}applications/details`,
  APPLICATION_REVIEW: `${OPEN_URL}audit/applications/review`,
  APPLICATION_REVIEW_SUBMIT: `${OPEN_URL}audit/applications/review`,
  APPLICATION_SUMMARY: `${OPEN_URL}onboarding/applications-summary`,
  APPLICATIONS_REVIEWED: `${OPEN_URL}audit/applications/reviewed`,
  AUDIT_APPLICATION_DETAIL: `${OPEN_URL}audit/applications/formdata`,
  AUDIT_CREDENTIAL_DETAIL: `${OPEN_URL}credentials/issued`,

  DISCOVERY_SEARCH: `${OPEN_URL}credentials/search?search=`,
  DISCOVERY_TAG: `${OPEN_URL}credentials/tags`,

  DISCOVERY_TAG_SEARCH: `${OPEN_URL}credentials/templates?`,
  DISCOVERY_TEMPLATE: `${OPEN_URL}credentials/categories/templates?`,
  CREDENTIAL_TEMPLATE_DETAILS: `${OPEN_URL}credentials/templates/`,
  CREDENTIAL_TEMPLATE_ONBOARDING_DETAILS: `${OPEN_URL}workflow/get-workflowsteps/`,

  GET_CREDENTIALS_TEMPLATE_DESIGN: `${OPEN_URL}credentials/`,
  POST_CREDENTIALS_TEMPLATE_DESIGN: `${OPEN_URL}credentials/`,

  GET_CREDENTIALS_SUBJECT_FORM: `${OPEN_URL}credentials/`,

  POST_CREDENTIALS_SINGLE_ISSUANCE: `${OPEN_URL}credentials/issue/single?credential_template=`,
  POST_CREDENTIALS_BULK_ISSUANCE: `${OPEN_URL}credentials/issue/bulk?credential_template=`,

  GET_USER_PREVIEW_SVG: `${OPEN_URL}credentials/template/issuer`,

  GET_USER_PRESENTATION_SVG: `${OPEN_URL}credentials/presentation`,
  GET_USER_BULK_TRANSACTION_DETAILS: `${OPEN_URL}credentials/issued`,
  ACTIVATE_ACCOUNT: `${OPEN_URL}verifier/activate`,
  GET_TRANSACTIONS_DETAILS: `${OPEN_URL}verifier/transactions`,
  GET_TRANSACTIONS_INDIVIDUAL_DETAILS: `${OPEN_URL}credentials/transactions`,

  GET_ISSUER_DRAFTS: `${OPEN_URL}credentials/templates/issuer/`,
  GET_DRAFT_CERTIFICATE_DATA: `${OPEN_URL}credentials/template/issuer?issuer_credential_template_id=`,
  // GET_DRAFT_CERTIFICATE_DATA: `${OPEN_URL}credentials/templates/issuer/`,

  G_LOGIN: `${OPEN_URL}verifier/social-login/google`,
  MICROSOFT_LOGIN: `${OPEN_URL}verifier/social-login/microsoft`,
  MICROSOFT_AUTH_CODE:
    "https://login.microsoftonline.com/common/oauth2/v2.0/token",

  SEND_NOTIFICATION: `${OPEN_URL}notification/send`,

  GET_EMAIL_WHATSAPP_DEFAULT_DETAILS: `${OPEN_URL}credentials/`,

  GET_DEFAULT_EMAIL_WHATSAPP: `${OPEN_URL}notification/details?credential_id=`,

  DISCOVERY_DEFAULT_CATEGORY: `${OPEN_URL}credentials/categories`,

  TEMPLATE_PER_CATEGORY: `${OPEN_URL}credentials/categories/templates?`,

  GET_QR_IMAGE: `${OPEN_URL}users/settings/qr-code/logo`,

  POST_LOGO_FOR_QR: `${OPEN_URL}users/settings/qr-code/logo`,

  GET_DRAFTS_TEMPLATES: `${OPEN_URL}credentials/templates/issuer/?`,

  DOWNLOAD_SVG_AS_ZIP: `${OPEN_URL}credentials/download?transaction_id=`,

  DOWNLOAD_SVG_AS_PNG: `${OPEN_URL}credentials/download?credential_id=`,

  VERIFY_CREDENTIAL: `${OPEN_URL}credentials/verify/details?format=json`,
  VERIFY_CREDENTIAL_NO_AUTH: `${OPEN_URL}credentials/verify/no-auth-details?format=json&encoded_data=`,

  UPDATE_TRANSACTION_COMMENT: `${OPEN_URL}verifier/transactions/update`,

  GET_ALL_ISSUERS_LIST: `${OPEN_URL}verifier/issuers/list`,

  POST_FORGOT_PASSWORD: `${OPEN_URL}verifier/forgot-password/request`,
  POST_UPDATE_PASSWORD: `${OPEN_URL}verifier/update-password/update`,

  GET_REFRESH_ACCESS_TOKEN: `${OPEN_URL}verifier/token/refresh/`,

  PAYMENT_STATUS: `${OPEN_URL}credentials/verify/details/status`,

  GET_ISSUER: `${OPEN_URL}verifier/legacy-certificates/allowed-issuers`,
  GET_PROGRAMME: `${OPEN_URL}verifier/legacy-certificates/issuer-programmes`,
  GET_TEMPLATES: `${OPEN_URL}verifier/legacy-certificates/categories`,
  GET_VERIFY_FORM_DATA: `${OPEN_URL}verifier/legacy-certificates/category/form`,
  POST_LEGACY_PAYMENT: `${OPEN_URL}verifier/legacy-certificates/verify`,
  LEGACY_PAYMENT_STATUS: `${OPEN_URL}verifier/legacy-certificates/verify/status`,

  GET_ORGANISATION_DETAILS: `${OPEN_URL}verifier/assets`,

  GET_VP_CHECKS_CATEGORY_LIST: `${OPEN_URL}verifier/vp/categories/all`,
  GET_VP_CHECKS_LIST: `${OPEN_URL}verifier/vp/categories/`,
  GET_VP_QR_CODE: `${OPEN_URL}verifier/vp/presentation/`,
  GET_VP_RESULT: `${OPEN_URL}verifier/vp/verify/`,

  GET_BATCHES: `${OPEN_URL}verifier/legacy-certificates/issuer-batches`,
  GET_TEMPLATES: `${OPEN_URL}verifier/legacy-certificates/categories`,

  GET_CUSTOM_PROGRAMME_BATCH: `${OPEN_URL}verifier/organization-verifcation-form`,
  POST_FORM_CUSTOM_PROGRAMME_BATCH: `${OPEN_URL}verifier/legacy-certificates/data/verify`,
  DOWNLOAD_INVOICE: `${OPEN_URL}verifier/invoice/download`,

  POST_OCR_DOCUMENT: `${OPEN_URL}verifier/ocr/extract`,
  UPDATE_POST_FORM_DATA: `${OPEN_URL}verifier/ocr/verification`,
  GET_UPDATED_FORM_DATA: `${OPEN_URL}verifier/ocr/status`,

  POST_EMAIL_DOMAIN: `${OPEN_URL}verifier/check-email-domain`,

  POST_DOWNLOAD_TRANSACTIONS: `${OPEN_URL}verifier/verifications-approvals/export-excel/create`,
  GET_DOWNLOAD_TRANSACTIONS_STATUS: `${OPEN_URL}verifier/verifications-approvals/export-excel`,
};
export default EntityConstants;
